export enum ROUTES {
  HOME = '/',
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up',
  FIND_CONSULTANT = '/consultants',
  FIND_FRANCHISORS = '/franchisors',
  CONSULTANT = '/consultants/:id',
  FRANCHISOR = '/franchisors/:id',
  DASHBOARD = '/dashboard',
  PAYMENTS = '/payments',
  MY_SESSIONS = '/sessions',
  MY_BOOKINGS = '/bookings',
  BOOKING = '/bookings/:id',
  TERRITORY_SCOUT = '/territory-scout',
  CHATS = '/chats',
  CHAT = '/chats/:id',
  ACTIVATE_PROFILE = '/activate-profile',
  ACTIVATE_PROFILE_FRANCHISOR = '/activate-profile-franchisor',
  MY_PROFILE = '/my-profile',
  MY_PROFILE_GENERAL = '/my-profile/general',
  MY_PROFILE_CALENDAR = '/my-profile/calendar',
  MY_PROFILE_CONTACT = '/my-profile/contact',
  MY_PROFILE_FINANCIAL = '/my-profile/financial',
  MY_PROFILE_TRAINING = '/my-profile/training',
  MY_PROFILE_CHANGE_PASSWORD = '/my-profile/change-password',
  MY_PROFILE_PAYMENT = '/my-profile/payment-methods',
  MY_PROFILE_PAYMENT_DETAILS = '/my-profile/payment-details',
  MY_PROFILE_PAYOUT = '/my-profile/payout-details',
  MY_PROFILE_SUBSCRIPTION = '/my-profile/subscription',
  MY_PROFILE_BILLING = '/my-profile/billing',
  // MY_PROFILE_ACCOUNT_STATUS = '/my-profile/account-status',
  MY_PROFILE_REFERRAL_FEE = '/my-profile/referral-fee',
  MY_PROFILE_REFERRAL_TERMS = '/my-profile/referral-terms',
  CONSULTANT_PROFILE = '/consultant-profile',
  ADMIN_DASHBOARD = '/control-panel',
  ADMIN_PROFILE = '/control-panel/profile',
  ADMIN_PAYMENTS = '/control-panel/payments',
  ADMIN_PROMOTIONS = '/control-panel/promotions',
  ADMIN_BOOKINGS = '/control-panel/bookings',
  ADMIN_BOOKINGS_DETAILED_PAGE = '/control-panel/bookings/:id',
  ADMIN_FRANCHISES = '/control-panel/franchisors',
  ADMIN_FRANCHISES_DETAILED_PAGE = '/control-panel/franchisors/:id',
  ADMIN_FRANCHISES_CREATE_DETAILS = '/control-panel/franchisors/create',
  ADMIN_FRANCHISES_EDIT_DETAILS = '/control-panel/franchisors/:id/edit',
  ADMIN_CONSULTANTS = '/control-panel/consultants',
  ADMIN_CONSULTANTS_DETAILED_PAGE = '/control-panel/consultants/:id',
  ADMIN_CONSULTANTS_CREATE_DETAILS = '/control-panel/consultants/create',
  ADMIN_CONSULTANTS_EDIT_DETAILS = '/control-panel/consultants/:id/edit',
  ADMIN_DASHBOARD_SIGN_IN = '/control-panel/auth/sign-in',
  ADMIN_DASHBOARD_FORGOT_PASSWORD = '/control-panel/auth/forgot-password',
  ADMIN_CONSULTANT_REFERENCE = '/control-panel/consultant-reference',
  ADMIN_BRAND_NAMES = '/control-panel/brand-names',
  ADMIN_REVIEWS = '/control-panel/reviews',
  PRIVACY_AND_POLICY = '/privacy-policy',
  TERMS_OF_USE_CONSULTANT = '/terms-of-use/consultant',
  TERMS_OF_USE_FRANCHISOR = '/terms-of-use/franchisor',
  TERMS_AND_CONDITIONS = '/terms-and-conditions',
  ADMIN_BRAND_MAPPING_MANAGEMENT = '/control-panel/brand-mapping-management',
  ADMIN_EMAIL_MANAGEMENT = '/control-panel/email-management',
  ADMIN_ADMINISTRATORS = '/control-panel/administrators',
  ADMIN_SETTINGS = '/control-panel/settings',
  ADMIN_API_KEYS = '/control-panel/api-keys',
  ADMIN_LEGAL_DOCUMENTS = '/control-panel/legal-documents',
  ADMIN_LEGAL_DOCUMENTS_EDIT = '/control-panel/legal-documents/:documentType/:audience/edit',
  ADMIN_FREE_LISTING = '/control-panel/free-listing',
  ADMIN_POPUP = '/control-panel/pop-up',
}
